import React, {
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from 'react'
import { connect } from 'react-redux'
import { Link, Redirect, Route, Switch, withRouter } from 'react-router-dom'
import TabsNav from '../TabsNav'
import { getLabelFromValue } from '../../helpers'
import { Badge, Navbar, Row } from 'react-bootstrap'
import { ProtectedRoute } from '../../router/shared/ProtectedRoute'
import AppPage from '../../router/routes/App/AppPage'
import useBottomScrollListener from '../../hooks/useBottomScrollListener'
import {
  defaultBookingStatus,
  defaultCompanyStatus,
  defaultUserStatus,
} from '../../constants'
import { SmallUp, SmallDown } from '../Responsive/breakpoints'
import Supportbar from './Supportbar'
import {
  fetchNotificationsList,
  getChatsList,
  logout,
  removeFCMToken,
} from '../../actions'
import { isMobile } from '../../helpers'
import MasquradeBanner from 'components/MasquradeBanner'
import TooltipOnHover from 'components/TooltipOnHover'
import moment from 'moment'
import 'moment-timezone'
import CarouselComponent from 'components/Events/Carousel'
import AddTaskModal from 'components/AddTaskModal'
import RolzoCountryModal from 'pages/App/SystemPages/RolzoLocations/Countries/RolzoCountryModal'
import RolzoCityModal from 'pages/App/SystemPages/RolzoLocations/Cities/RolzoCityModal'
import { connectedApiService } from 'index'
import { showNotification } from '../../actions'
const isMobileBrowser = isMobile()

const DefaultLayout = React.forwardRef(
  (
    {
      onOpenSessionManager,
      onOpenEmailAccountManager,
      onComposeEmail,
      onMasquerade,
      userCompanyId = '',
      isAdminBookingDetailsPage = false,
      openSupportChatFromQuotes = false,
      setOpenSupportChatFromQuotes,
      currentDate = null,
      isGlobalRates = false,
      isStickyHeader = false,
      isHomeBookingDetailsPage = false,
      isSupportAdmin = false,
      isHomePage,
      notifications,
      isMainClientPage = false,
      isClientBookingsList = false,
      isAddClientPage = false,
      ratesAnomaliespage = false,
      PageMarginZero = false,
      tabsContentFullWidth = false,
      isHomePageLayout,
      newBooking,
      isAccount,
      isInvoicesPage,
      className = '',
      title = '',
      subtitle = '',
      apiBadge = false,
      bookingAdminMobile = false,
      subTitleBadgeGrey = null,
      subTitleBadgeBlack = null,
      children = null,
      // fixedChildren = null,
      addPath = null,
      addEvent = null,
      rolzoLocationCountryPage = false,
      rolzoLocationCityPage = false,
      addPathMapping = null,
      clonePath = null,
      showClose = false,
      showClone = false,
      showBack = false,
      showLogo = false,
      logoSrc = null,
      isBookingView = false,
      isSettingsView = false,
      showMobileTitle = false,
      isMyProfile = false,
      parentPath = '',
      onScrollBottom = () => {},
      showStepper,
      steps = null,
      isSelectingVehicle = false,
      activeStep = null,
      tabs = null,
      isLoggedIn,
      hideSidebar,
      companyId,
      match,
      history,
      onBack = null,
      noLeftPadding,
      noTitle,
      isChatNotification = false,
      company,
      userCompany,
      companyVerified,
      user,
      userLabel,
      companyLabel,
      isPassengerVip = false,
      isClientUserPage,
      isClientPage,
      isRolzoFirst,
      userPhone,
      userIp,
      companyPhone,
      isAdmin = false,
      fromQuote,
      fromDraft,
      fromEvent,
      eventId = '',
      subLink,
      subLinkUrl,
      subLinkImg,
      unreadMessages = 0,
      onToggleUpdate,
      logout,
      isMasqueradeUser,
      currentUser = null,
      isQuoteClient = false,
      showWarningBanner = false,
      bookingIsConfirmed,
      // currentAdminInfo,
      removePageMargin,
      isSupplierList = false,
      isSupplier = false,
      supplierStatus,
      supplierScore,
      supplierRating = 0,
      supplier24HourService = false,
      whatsapp = false,
      updateSupplierRating = () => {},
      update24HourService = () => {},
      onMarkBookingBespoke = () => {},
      onMarkVipPassenger = () => {},
      onMarkBookingImporant = () => {},
      updateWhatsappValue = () => {},
      updateImportantValue = () => {},
      important,
      importantBooking,
      escalationBooking,
      bookingId,
      hasVipMg,
      bookingType,
      userFirstBooking,
      isPayout = false,
      payoutStatus,
      payoutCompany,
      payoutCompanyId,
      isPayoutList = false,
      isRatesGrid = false,
      isNewBooking = false,
      isRatesList = false,
      isSearchStep = false,
      isVipMeetGreet = false,
      isEditClientPage = false,
      updatePaymentsTabs = () => {},
      isAdminBookings = false,
      createdBy,
      removeFCMToken,
      showNotification,
      userId,
      isAdminList = false,
      isNewEvent = false,
      isAnalytics = false,
      pricingModel,
      rateGridStyle = false,
      isPartnerBooking = false,
      isB2CBooking = false,
      isB2CUser = false,
      bookingFor = null,
      isReferral = false,
      userEmail,
      userLocalTimeZone = null,
      setCreatedId,
      setCreatedBooking,
      setDoorToDoorValues,
      setFlightTrackingPickUp,
      setFlightTrackingDropOff,
      isBespokeBooking = false,
      companyRoles,
      isEventPage = false,
      isInviteNewGuestPage = false,
      isIndependentDriver = false,
      isVipClient = false,
    },
    ref
  ) => {
    const [showTracker, setShowTracker] = useState(false)
    const [showEscalation, setShowExcalation] = useState(false)
    const [tasklinks, setTaskLinks] = useState({
      hasSupplyTask: false,
      hasClientTask: false,
      hasOperationsTask: false,
      hasEscalationTask: false,
      hasFinanceTask: false,
    })

    const isIframeView = window.parent !== window.self

    const [isBookingNoCopied, setIsBookingNoCopied] = useState(false)
    const [showRolzoCountryModal, setShowRolzoCountryModal] = useState(false)
    const [showRolzoCityModal, setShowRolzoCityModal] = useState(false)

    const [rating, setRating] = useState(supplierRating)
    const [twentyFourHourService, setTwentyFourHourService] = useState(
      supplier24HourService
    )
    const [bespokeService, setBespokeService] = useState(isBespokeBooking)
    const [vipService, setVipService] = useState(isPassengerVip)
    const [importantService, setImportantService] = useState(importantBooking)
    const [escalationService, setEscalationService] = useState(
      escalationBooking
    )
    const [supplierOnWhatsapp, setSupplierOnWhatsapp] = useState(whatsapp)
    const [importantClient, setImportantClient] = useState(important)

    const [userLocalTime, setUserLocalTime] = useState(
      userLocalTimeZone
        ? moment()
            .tz(userLocalTimeZone)
            .format('ddd, D MMM YYYY, HH:mm')
        : null
    )
    useEffect(() => {
      if (!userLocalTimeZone) {
        setUserLocalTime(null)
        return
      }
      const update = () =>
        setUserLocalTime(
          moment()
            .tz(userLocalTimeZone)
            .format('ddd, D MMM YYYY, HH:mm')
        )
      update()
      const now = new Date()
      const msUntilNextMinute =
        (60 - now.getSeconds()) * 1000 - now.getMilliseconds()
      let intervalId
      const timeoutId = setTimeout(() => {
        update()
        intervalId = setInterval(update, 60000)
      }, msUntilNextMinute)
      return () => {
        clearTimeout(timeoutId)
        if (intervalId) clearInterval(intervalId)
      }
    }, [userLocalTimeZone])

    var existUnreadNotices = notifications && notifications > 0
    const scrollRef = useRef(null)
    useEffect(() => {
      if (openSupportChatFromQuotes) history.push('/chat-client')
    }, [history, openSupportChatFromQuotes])

    useEffect(() => {
      const fetchTaskCounts = async bookingId => {
        try {
          const response = await connectedApiService.get(
            `tasks/find/${bookingId}`
          )
          setTaskLinks(response.data)
        } catch (error) {
          console.error('Error fetching logs:', error)
        }
      }

      if (bookingId) {
        fetchTaskCounts(bookingId)
      }
    }, [bookingId])

    useEffect(() => {
      const handleScroll = () => {
        if (scrollRef.current) {
          if (scrollRef.current.scrollTop > 20) {
            document
              .querySelector('.animated-header')
              .classList.remove('border-0')
            document
              .querySelector('.animated-header-text')
              .classList.add('show-booking-title')
          } else {
            document.querySelector('.animated-header').classList.add('border-0')
            document
              .querySelector('.animated-header-text')
              .classList.add('hide-booking-title')
            document
              .querySelector('.animated-header-text')
              .classList.remove('show-booking-title')
          }
        }
      }

      const currentRef = scrollRef.current

      if (currentRef && isHomeBookingDetailsPage) {
        currentRef.addEventListener('scroll', handleScroll) // Attach the scroll event
      }

      return () => {
        if (currentRef && isHomeBookingDetailsPage) {
          currentRef.removeEventListener('scroll', handleScroll) // Cleanup listener
        }
      }
    }, []) // Empty dependency array ensures it runs only on mount/unmount
    useBottomScrollListener(onScrollBottom, scrollRef, 100, 300)
    useImperativeHandle(ref, () => ({
      scrollToTop: () => {
        scrollRef.current.scrollTo({
          top: 0,
        })
      },
    }))
    const tabsToNav = useMemo(
      () =>
        !tabs
          ? null
          : tabs
              .filter(tab => !!tab.hasAccess)
              .map(tab => ({
                ...tab,
                path: `${match.url}${tab.path}`,
              })),
      [tabs, match]
    )

    const onBackClick = e => {
      e.preventDefault()
      if (onBack) {
        onBack()
      } else if (isHomeBookingDetailsPage) {
        history.push('/home', { currentDate: new Date(currentDate) })
      } else {
        if (history.location.pathname === '/booking/main/new-booking') {
          history.push('/')
        } else {
          history.goBack()
        }
      }
    }
    const handleCopyToClipboard = async bookingNo => {
      const result = bookingNo.split('#')[1]
      const origin = window.location.origin
      const url = `${origin}/sales-bookings/${bookingId}`
      const html = `<a href="${url}">${result}</a>`
      const plainText = url

      try {
        if (typeof ClipboardItem !== 'undefined') {
          const htmlBlob = new Blob([html], { type: 'text/html' })
          const textBlob = new Blob([plainText], { type: 'text/plain' })

          const data = [
            // eslint-disable-next-line no-undef
            new ClipboardItem({
              'text/html': htmlBlob,
              'text/plain': textBlob,
            }),
          ]

          await navigator.clipboard.write(data)
        } else {
          await navigator.clipboard.writeText(url)
        }
      } catch (err) {
        console.error('Failed to copy:', err)
      }
      setIsBookingNoCopied(true)
      setTimeout(() => setIsBookingNoCopied(false), 3000)
    }
    useEffect(() => {
      setRating(supplierRating)
    }, [supplierRating])

    useEffect(() => {
      setTwentyFourHourService(supplier24HourService)
    }, [supplier24HourService])

    useEffect(() => {
      setBespokeService(isBespokeBooking)
    }, [isBespokeBooking])

    useEffect(() => {
      setVipService(isPassengerVip)
    }, [isPassengerVip])

    useEffect(() => {
      setImportantService(importantBooking)
    }, [importantBooking])

    useEffect(() => {
      setEscalationService(escalationBooking)
    }, [escalationBooking])

    useEffect(() => {
      setSupplierOnWhatsapp(whatsapp)
    }, [whatsapp])

    useEffect(() => {
      setImportantClient(important)
    }, [important])

    const HeaderMenuLink = ({
      icon,
      isSelected,
      existUnread,
      onClickHandle,
      showAlertBadge = false,
      counts = 0,
      isAdmin,
    }) => {
      if (isAdmin) {
        return (
          <div className='bottom-nav-link' onClick={onClickHandle}>
            <div className='bottom-nav-img-wrapper'>
              <img
                width={24}
                height={24}
                className='bottom-nav-link-img'
                src={'/images/' + icon}
                alt=''
              />
              {showAlertBadge && counts > 0 ? (
                <div className='bottom-menu-unread-indicator' />
              ) : (
                ''
              )}
            </div>
          </div>
        )
      } else {
        return (
          <div className='bottom-nav-link' onClick={onClickHandle}>
            <div className='bottom-nav-img-wrapper'>
              <img
                width={24}
                height={24}
                className='bottom-nav-link-img'
                src={'/images/' + icon}
                alt=''
              />
              {existUnread ? (
                <div className='bottom-menu-unread-indicator' />
              ) : (
                ''
              )}
            </div>
          </div>
        )
      }
    }
    function clickMenu(path) {
      if (path === '/notifications-client') {
        fetchNotificationsList()
      } else if (path === '/chat-client') {
        getChatsList()
      }
      history.push(path)
    }
    const HeaderMenuItem = ({
      path,
      icon,
      currentPath,
      childAllowedRoutes,
      existUnread,
      onClickHandle,
      showAlertBadge = false,
      counts = 0,
      isAdmin,
    }) => {
      var isSelected = currentPath && currentPath.startsWith(path)
      if (!childAllowedRoutes) {
        return (
          <HeaderMenuLink
            title={title}
            icon={icon}
            isSelected={isSelected}
            existUnread={existUnread}
            onClickHandle={onClickHandle}
            showAlertBadge={showAlertBadge}
            counts={counts}
            isAdmin={isAdmin}
          />
        )
      }

      return (
        <>
          {childAllowedRoutes
            .filter(({ hideInSidebar }) => !hideInSidebar)
            .map(child => (
              <div key={child.path}>
                <HeaderMenuLink
                  key={child.path}
                  title={child.title}
                  icon={isSelected ? child.iconActive : child.iconInactive}
                  isSelected={isSelected}
                  existUnread={existUnread}
                  onClickHandle={onClickHandle}
                  isAdmin={isAdmin ? true : false}
                />
              </div>
            ))}
        </>
      )
    }
    // useEffect(() => {
    //   const originalConsoleLog = console.log
    //   console.log = function(message) {
    //     try {
    //       // Send log messages to React Native using postMessage
    //       window.ReactNativeWebView.postMessage(
    //         JSON.stringify({ type: 'log', message: message })
    //       )
    //     } catch (error) {
    //       // Handle the error, if any
    //     }
    //     // Call the original console.log to display logs in the web console
    //     originalConsoleLog.apply(console, arguments)
    //   }
    // }, [currentUser])
    let isClient = companyId ? true : false
    const isCompanyAdmin = companyRoles => {
      const isAdmin = companyRoles.includes('company_admin')
      return isAdmin
    }

    const [showReferralBanner, setShowReferralBanner] = useState(
      localStorage.getItem('closeReferralBanner') === 'true' ? false : true
    )
    const onHideReferralBanner = () => {
      setShowReferralBanner(false)
      localStorage.setItem('closeReferralBanner', 'true')
    }

    const oneStar = document.querySelector('#rating-1')
    const twoStars = document.querySelector('#rating-2')
    const threeStars = document.querySelector('#rating-3')
    const fourStars = document.querySelector('#rating-4')
    const fiveStars = document.querySelector('#rating-5')

    if (oneStar && twoStars && threeStars && fourStars && fiveStars) {
      ;[oneStar, twoStars, threeStars, fourStars, fiveStars].forEach(function(
        elem
      ) {
        elem.addEventListener('change', function() {
          if (rating === parseInt(elem.getAttribute('value'))) {
            setRating(null)
            updateSupplierRating(null)
          } else {
            setRating(parseInt(elem.getAttribute('value')))
            updateSupplierRating(parseInt(elem.getAttribute('value')))
          }
        })
      })
    }
    const twentyFourEnabled = document.querySelector('#twenty-four-icon')

    if (twentyFourEnabled) {
      twentyFourEnabled.addEventListener('click', function() {
        setTwentyFourHourService(!twentyFourHourService)
        update24HourService(!twentyFourHourService)
      })
    }

    const bespokeEnabled = document.querySelector('#bespoke-icon')

    var bespokeServiceHandle = function(e) {
      e.preventDefault()
      setBespokeService(!bespokeService)
      onMarkBookingBespoke()
    }

    if (bespokeEnabled) {
      bespokeEnabled.onclick = bespokeServiceHandle
    }

    const vipEnabled = document.querySelector('#vip-icon')

    var vipServiceHandle = function(e) {
      e.preventDefault()
      setVipService(!vipService)
      onMarkVipPassenger()
    }

    if (vipEnabled) {
      vipEnabled.onclick = vipServiceHandle
    }

    const importantEnabled = document.querySelector('#important-icon')

    var importantServiceHandle = function(e) {
      e.preventDefault()
      setImportantService(!importantService)
      onMarkBookingImporant()
    }

    if (importantEnabled) {
      importantEnabled.onclick = importantServiceHandle
    }

    const escalationEnabled = document.querySelector('#escalation-icon')

    var escalationServiceHandle = async function(e) {
      e.preventDefault()
      if (escalationService === true) {
        let result =
          (await connectedApiService.get(
            `tasks/escalationCheck/${bookingId}`
          )) || {}

        if (result.data.message === true) {
          showNotification({
            message: 'Escalation needs to be resolved first',
            type: 'error',
          })
          return
        }
      }

      if (escalationService === false) {
        setShowExcalation(true)
        setShowTracker(true)
      }
    }

    if (escalationEnabled) {
      escalationEnabled.onclick = escalationServiceHandle
    }

    const whatsappEnabled = document.querySelector('#whatsapp-icon')

    if (whatsappEnabled) {
      whatsappEnabled.addEventListener('click', function() {
        setSupplierOnWhatsapp(!supplierOnWhatsapp)
        updateWhatsappValue(!supplierOnWhatsapp)
      })
    }

    const importantClientEnabled = document.querySelector(
      '#important-client-icon'
    )

    if (importantClientEnabled) {
      importantClientEnabled.addEventListener('click', function() {
        setImportantClient(!importantClient)
        updateImportantValue(!importantClient)
      })
    }
    const clientLogOut = async () => {
      try {
        //remove FCM token for react native clients
        if (window.ReactNativeWebView) {
          await removeFCMToken(userId, navigator.userAgent)
        }
        await logout()
      } catch (error) {
        console.log('clientLogOut error', error)
      }
    }

    const renderTabs = () => {
      if (!tabs || !tabs.length) {
        return
      }

      if (!tabsToNav || !tabsToNav.length) {
        return <Redirect to='/' />
      }

      //mobile view account
      if (isSettingsView && isMobileBrowser) {
        return (
          <>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              {company.isRolzoFirstMember && title === 'Account' ? (
                <div
                  className='rolzo-first-label-client'
                  style={{
                    textTransform: 'none',
                    width: '6.3rem',
                    marginBottom: '1.2rem',
                  }}
                >
                  <span>ROLZO First </span>
                  <img
                    src='/images/icons/rolzo-first-star.png'
                    alt=''
                    style={{
                      height: '13px',
                      width: '13px',
                      marginTop: '0.09rem',
                      marginLeft: '0.2rem',
                    }}
                  />
                </div>
              ) : (
                <></>
              )}
            </div>
            <div
              className='light-tabs-content'
              style={
                title === 'Bookings' || title === 'Bookings POC' || isAnalytics
                  ? { maxWidth: '100%' }
                  : title === 'Quotes'
                  ? { maxWidth: '1200px' }
                  : {}
              }
            >
              <Switch>
                <Route
                  exact
                  path={`${match.path}`}
                  render={() => (
                    <>
                      <div className='useless-class'>
                        {tabs.map(({ title = '', path, key }, index) => {
                          if (path) {
                            return (
                              <Row
                                className={'settings-row'}
                                onClick={() => {
                                  history.push(`/settings/main${path}`)
                                }}
                              >
                                <div className={'settings-option'} key={path}>
                                  {title}
                                  <img
                                    src={`/images/icons/not_blurry_arrow.png`}
                                    alt=''
                                  />
                                </div>
                              </Row>
                            )
                          }
                          return (
                            <Row className='settings-row'>
                              <div
                                className='settings-option'
                                key={key}
                                onClick={() => {
                                  history.push(`/settings/main${path}`)
                                }}
                                eventKey={key}
                              >
                                {title}
                                <img
                                  src={`/images/icons/not_blurry_arrow.png`}
                                  alt=''
                                />
                              </div>
                            </Row>
                          )
                        })}
                        <div
                          className='settings-logout-img-wrapper'
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: '5rem',
                            color: '#a79779',
                            fontSize: '16px',
                          }}
                          onClick={clientLogOut}
                        >
                          <img
                            style={{ marginRight: '0.5em', height: '1.3125em' }}
                            src='/images/icons/icon-mobile-logout.png'
                            alt=''
                          />
                          {'Log out'}
                        </div>
                      </div>
                    </>
                  )}
                />

                {tabs.map(route => {
                  const { path, isPrivate, hasAccess } = route
                  return (
                    <ProtectedRoute
                      key={path}
                      isLoggedIn={isLoggedIn}
                      isPrivate={isPrivate}
                      path={`${match.url}${path}`}
                      exact={route.exact}
                      hasAccess={hasAccess}
                      isAccountView={title === 'Account'}
                      component={() => (
                        <AppPage
                          isTabRoute
                          isLoggedIn={isLoggedIn}
                          parentPath={path}
                          scrollRef={scrollRef}
                          updatePaymentsTabs={
                            updatePaymentsTabs ? updatePaymentsTabs : null
                          }
                          {...route}
                        />
                      )}
                    />
                  )
                })}
              </Switch>
            </div>
          </>
        )
      }

      return (
        <>
          <TabsNav
            align='start'
            tabs={tabsToNav}
            sectionTabs={
              company &&
              company.useInternalBookingId &&
              (title === 'Bookings' || title === 'Quotes')
                ? true
                : false
            }
            isAdminBookings={isAdminBookings}
            className={`${
              title === 'Bookings' && isMobileBrowser
                ? 'light-tabs-mobile'
                : 'light-tabs'
            }`}
            isReferral={title === 'Referral' && isMobileBrowser ? true : false}
          />
          <div
            className={`${
              tabsContentFullWidth ? 'w-100' : 'light-tabs-content'
            }`}
            style={
              title === 'Bookings' || title === 'Bookings POC' || isAnalytics
                ? { maxWidth: '100%' }
                : title === 'Quotes'
                ? { maxWidth: '1200px' }
                : {}
            }
          >
            <Switch>
              <Route
                exact
                path={`${match.path}`}
                render={() => (
                  <Redirect replace to={`${match.url}${tabs[0].path}`} />
                )}
              />
              {tabs.map(route => {
                const { path, isPrivate, hasAccess } = route
                return (
                  <ProtectedRoute
                    key={path}
                    isLoggedIn={isLoggedIn}
                    isPrivate={isPrivate}
                    path={`${match.url}${path}`}
                    exact={route.exact}
                    hasAccess={hasAccess}
                    component={() => (
                      <AppPage
                        isTabRoute
                        isLoggedIn={isLoggedIn}
                        parentPath={path}
                        scrollRef={scrollRef}
                        isAccountView={title === 'Account'}
                        updatePaymentsTabs={
                          updatePaymentsTabs ? updatePaymentsTabs : null
                        }
                        {...route}
                      />
                    )}
                  />
                )
              })}
            </Switch>
          </div>
        </>
      )
    }

    const renderStepper = () => {
      if (!showStepper || isNewBooking) {
        return
      }

      return (
        <>
          {/* <SmallUp>
            <Stepper isQuoteClient={isQuoteClient}>
              {steps.map((step, index) => {
                const { title, indicator } = step
                return (
                  <Step
                    key={String(index)}
                    title={title}
                    indicator={indicator}
                    active={index === activeStep}
                    isQuoteClient={isQuoteClient}
                  />
                )
              })}
            </Stepper>
          </SmallUp> */}
        </>
      )
    }

    const mobileSidebarToggle = e => {
      e.preventDefault()
      document.documentElement.classList.toggle('nav-open')
      let node = document.createElement('div')
      node.id = 'bodyClick'
      node.onclick = function() {
        this.parentElement.removeChild(this)
        document.documentElement.classList.toggle('nav-open')
      }
      document.body.appendChild(node)
    }
    const companyLogo =
      company &&
      (company.logo ? (
        <div className='company-logo float-left has-logo'>
          <img src={company.logo} alt='' />
        </div>
      ) : (
        <div className='company-sm-logo float-left'>
          {company.name.substring(0, 1)}
        </div>
      ))

    return (
      <>
        {!hideSidebar &&
        !!companyId &&
        // This is a temp fix, till i have time to look into it
        document.getElementById('app-page') &&
        document.getElementById('app-page').hasChildNodes() ? (
          <>
            <Supportbar
              onBack={onBack}
              isIframeView={isIframeView}
              setCreatedId={setCreatedId}
              setCreatedBooking={setCreatedBooking}
              setDoorToDoorValues={setDoorToDoorValues}
              setFlightTrackingDropOff={setFlightTrackingDropOff}
              setFlightTrackingPickUp={setFlightTrackingPickUp}
              openSupportChatFromQuotes={openSupportChatFromQuotes}
              setOpenSupportChatFromQuotes={setOpenSupportChatFromQuotes}
            />
            {showReferralBanner &&
            isReferral &&
            !isMobileBrowser &&
            title &&
            !isAdmin ? (
              <div className='referral-banner'>
                <div className='banner-header'>
                  <img
                    src='/images/referral_active.png'
                    className='referral-icon'
                    alt=''
                  ></img>
                  <p>
                    <span>ROLZO Referral:</span> Unlock $50 off your first
                    booking valued at $150 or more across 100 countries, 750
                    cities, and 1,000 airports.
                  </p>
                </div>
                <div className='right-div'>
                  <img
                    className='close-icon'
                    src='/images/icons/close-icon.png'
                    onClick={() => onHideReferralBanner()}
                    alt=''
                  ></img>
                </div>
              </div>
            ) : (
              <></>
            )}
          </>
        ) : (
          ''
        )}
        <div
          ref={scrollRef}
          className={`${
            !isAdmin && !isAdminBookings && !isAdminList
              ? 'scrollable-page-content'
              : ''
          } ${className || ''} ${
            hideSidebar ? 'scrollable-page-content-without-supportbar' : ''
          } ${noTitle ? 'no-title' : ''} ${
            removePageMargin ? 'lightThemeHeight' : ''
          } ${activeStep === 1 && isNewBooking ? 'stepTwoHeight' : ''}
          ${isHomeBookingDetailsPage ? 'isHomeBookingDetailsPage' : ''}
          `}
          style={
            isPayoutList
              ? { height: 'auto' }
              : (title === 'ROLZO First' ||
                  title === 'ROLZO Privé' ||
                  title === 'Referral') &&
                isMobileBrowser
              ? { overflow: 'scroll' }
              : {}
          }
        >
          {!isPayoutList && !isNewBooking && !isRatesList ? (
            // prettier-ignore
            <Navbar
              className={`${showStepper && isSelectingVehicle ? 'navbar-without-stepper' : '' } ${(isSettingsView || title==='Referral') && isMobileBrowser ? 'settings-page' : '' }
                          ${isInvoicesPage && isMobileBrowser ? 'p-0 mb-1': ''}
                          ${isChatNotification && isMobileBrowser ? 'h-fit py-12' : isChatNotification ? 'h-fit' : ''}
                          ${isEditClientPage && isMobileBrowser ? 'border-0' : ""}
                          ${(isMainClientPage || isHomeBookingDetailsPage || isStickyHeader) && isMobileBrowser ? 'sticky-header show-border' : ''}
                          ${
                            (isChatNotification && navigator && navigator.userAgent.includes('iPhone') && window.ReactNativeWebView) 
                              ? 'mob-chat-extra-padding' 
                              : ((isMainClientPage || isHomeBookingDetailsPage || isStickyHeader) 
                                  && navigator 
                                  && navigator.userAgent.includes('iPhone')) && window.ReactNativeWebView
                                ? 'mob-extra-padding' 
                                : ''
                          }
                          ${isHomeBookingDetailsPage && isMobileBrowser ? 'animated-header border-0' : ''}
                          ${title==='Referral' && isMobileBrowser ? 'show-border' : ''}
                    
              `}
              style={isHomeBookingDetailsPage ? {paddingBlock: '18px' , marginBottom: '0'}: {} }
            >
              <Navbar.Brand
                className={`${showBack || showClose || showStepper ? 'w-100' : ''
                  }`}
              >
                {
                  <>
                    <header
                      className={
                        !isMobileBrowser && isAdmin
                          ? `${'withoutBadge'}  
                          ${isAdminBookingDetailsPage ? 'Admin-booking-details-page' : ''} 
                          ${isEventPage ? 'event-name-admin' : ''} 
                          ${noTitle ? `no-title-header` : ''
                          }`
                          : `${noTitle && isSupportAdmin ? 'no-title-header support-admin' : noTitle ? 'no-title-header' : ''
                          } ${bookingAdminMobile &&
                          isMobileBrowser &&
                          'd-flex'}
                          ${isRatesGrid ? 'pt-0 mt-0 mr-0' : ''}
                          ${isMobileBrowser && isSettingsView ? 'mt-0': ''}
                          ${isChatNotification && isMobileBrowser ? 'm-0' : ''}
                          ${isPayout ? 'pb-0' : ''}
                          ${!isMobileBrowser && !isRatesGrid ? 'm-17-20' : ''}
                          ${isEditClientPage ? 'flex-column align-items-start' : ''}
                          ${isMainClientPage && isMobileBrowser ? 'mt-0' : ''}
                          ${addPathMapping || subtitle ? 'flex-column' : ''}
                          ${PageMarginZero ? 'p-0' : ''}
                          d-flex`
                      }
                      style={removePageMargin ? { paddingLeft: isGlobalRates ? '20px': '1%', marginTop: isGlobalRates ? '-25px' : '' } : rateGridStyle ? { paddingTop: '0px' } : {}}
                      // style={removePageMargin ? { paddingLeft: '1%' } : {}}
                    >
                      {!!showBack &&  !((isMainClientPage || isHomeBookingDetailsPage || isStickyHeader) && isMobileBrowser) && (
                        <div
                          className={`
                              ${noTitle ? 'no-title-back-btn-wrap' : ''} 
                              ${bookingAdminMobile && isMobileBrowser && 'align-self-end'}
                          `}
                        >
                          <SmallDown>
                            <a
                              id='back-btn'
                              href='/'
                              onClick={onBackClick}
                              style={{height:"22px", width:"16px", display:"flex"}}
                              className='layout-btn back-btn step-back-btn position-static m-0'
                            >
                              <img 
                              style={{width:"16px", height:"22px"}}
                              src={`/images/icons/chevronBack.svg`} alt='' />
                            </a>
                          </SmallDown>
                          {title && noTitle && (
                            <>
                              <h1
                                className={`
                                ${ isAdmin ? 'page-title-admin' : 'page-title' }
                                
                                `}
                                style={
                                  title === 'Support'
                                    ? { marginLeft: '0' }
                                    : title === 'External Apis'
                                      ? { margin: '0.4rem' }
                                      : {}
                                }
                              >
                                {title}
                              </h1>
                            </>
                          )}
                          {isMobileBrowser && !!userCompany && !!user && (
                            <div
                              className={
                                bookingAdminMobile && isMobileBrowser
                                  ? 'company-info-title-admin'
                                  : isAdmin
                                    ? 'company-info-title mt-0'
                                    : 'company-info-title'
                              }
                              style={
                                bookingAdminMobile && isMobileBrowser
                                  ? { flexDirection: 'column' }
                                  : {}
                              }
                            >
                              <h1 style={{ marginLeft: '7rem' }}>
                                {userCompany}
                              </h1>
                              <h4 style={{ marginLeft: '8rem' }}>{user}</h4>
                            </div>
                          )}
                          {bookingAdminMobile && isMobileBrowser && (
                            <span className={apiBadge || isPartnerBooking  || isB2CBooking ? 'd-flex' : ''}>
                              {title}{' '}
                              {isPartnerBooking ? (
                                 <div className='partnerBadgeBooking ml-2'>P</div>
                              ): <></>}
                              {isB2CBooking ? (
                                 <div className='partnerBadgeBooking ml-2'>W</div>
                              ): <></>}
                              {apiBadge && (
                                <div className='apiBadgeBookingMobile ml-2'>
                                  API
                                </div>
                              )}
                              {/* {(importantBooking || userFirstBooking) && (
                                <img
                                  src='/images/icons/icon-important.png'
                                  className='important-booking-badge'
                                  alt=''
                                />
                              )} */}
                            </span>
                          )}
                        </div>
                      )}
                      {!noTitle ? (
                        <>
                          {!showStepper ? (
                            <>
                              <div
                              style={
                                isAdmin && title && isAdminBookingDetailsPage
                                  ? {
                                      fontSize: '1.5rem',
                                      marginBottom: '0px',
                                    }
                                  : {
                                      marginBottom: ratesAnomaliespage ? "20px" : ""
                                    }
                              }
                                className={
                                  isAdmin
                                    ? `page-title-admin ${isChatNotification
                                      ? 'chatnotification-page-title'
                                      : ''
                                    }`
                                    : isEditClientPage ? 'edit-client-page-title h-fit' : bookingAdminMobile
                                      ? 'page-title-booking'
                                      : `page-title ${isChatNotification ? 'chatnotification-page-title' : '' } 
                                      ${isInvoicesPage ? 'invoices-page-title' : '' } 
                                      ${isAccount || title==='Referral' ? 'justify-content-between account-page-title' : '' } 
                                      ${ (isSettingsView || title==='Referral') && isMobileBrowser ? 'account-header' : '' }
                                      ${ isMainClientPage && isMobileBrowser ? 'h-fit w-100' : '' }
                                      
                                      `
                                }
                              >
                                {!!showLogo && (
                                  <>
                                    {!!logoSrc ? (
                                      <img
                                        className='layout-logo'
                                        src={logoSrc}
                                        alt=''
                                      />
                                    ) : (
                                      <div className='layout-logo'>
                                        {title.substring(0, 1)}3
                                      </div>
                                    )}
                                  </>
                                )}
                                {/* {!!isSettingsView && (
                                  <SmallDown>
                                    <div
                                      className='settings-logout-img-wrapper'
                                      onClick={clientLogOut}
                                    >
                                      <img
                                        src='/images/icons/logout_mobile.png'
                                        alt=''
                                      />
                                    </div>
                                  </SmallDown>
                                )} */}
                                {/* {console.log("currentUser", currentUser)} */}
                                {/* {window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'log', message: currentUser }))} */}
                                {currentUser && !((isMainClientPage || isHomeBookingDetailsPage || isStickyHeader) && isMobileBrowser) && (
                                  <SmallDown>
                                    <div className='settings-logout-img-wrapper' style={{display:'flex'}}>
                                      {/* {isMobileBrowser && company ? (
                                        <div className='rolzo-first-label-mobile'  onClick={() => history.push('/referrals/main')}>
                                          <img
                                              src='/images/referral_active.png'
                                              alt=''
                                              style={{
                                                height: '1.563rem',
                                                width: '1.563rem',
                                              }}
                                          />
                                        </div>
                                      ) : (
                                        <></>
                                      )} */}
                                      {company && isMobileBrowser && company.type !== 'supplier' && (company.industry === 'Lifestyle Management' || company.industry === 'Travel' || company.industry === 'Aviation') && (pricingModel?.commissionable || pricingModel?.netDiscount || company?.corporateBenefits?.defaultBenefits?.commissionWeight || company?.corporateBenefits?.defaultBenefits?.discountWeight || company.isRolzoFirstMember) && ((companyId === "vHzESuLR8vcZeNquL" && companyRoles && isCompanyAdmin(companyRoles)) || companyId !== "vHzESuLR8vcZeNquL") ? (
                                        <div className='rolzo-first-label-mobile'  onClick={() => history.push('/settings/main/rolzoFirst')}>
                                          <img
                                              src='/images/icons/rolzo-first-star-mobile.png'
                                              alt=''
                                              style={{
                                                height: '1.563rem',
                                                width: '1.563rem',
                                              }}
                                          />
                                        </div>
                                      ) : (
                                        <></>
                                      )} 
                                       {/* {company && company.type === 'supplier' ? (
                                          <Link to='/partner/auth'
                                            className='switch-client-btn-mob'
                                          >
                                            <span>Switch to partner</span>
                                            <img alt="" src='/images/icons/switch-gold.png'></img>
                                          </Link>
                                        ) : (
                                          <></>
                                       )} */}
                                      {currentUser.company &&
                                        currentUser.company.logo ? (
                                        <div>
                                          <img
                                            className='company-logo-top'
                                            src={company.logo}
                                            alt=''
                                            onClick={() => {
                                              isMobileBrowser ? history.push('/settings/main')
                                              : history.push('/settings/main/general')
                                            }}
                                          />
                                        </div>
                                      ) : (
                                        <div
                                          className={`profile-default-logo-top ${isMainClientPage ? 'd-none' : ''}`}
                                          onClick={() => {
                                            isMobileBrowser ? history.push('/settings/main')
                                            : history.push('/settings/main/general')
                                          }}
                                        >
                                          {currentUser.firstName.substring(0, 1)}
                                          {currentUser.lastName
                                            ? currentUser.lastName.substring(0, 1)
                                            : ''}
                                        </div>
                                      )}
                                    </div>
                                  </SmallDown>
                                )}
                                {!isBookingView && !showMobileTitle ? (
                                  <>
                                    {(title === 'Referral' || isSettingsView) && isMobileBrowser ? (                
                                      <a
                                        id='back-btn'
                                        href='/'
                                        onClick={onBackClick}
                                        className='layout-btn back-btn position-relative'
                                        style={{height: isEditClientPage ? "1.5rem" : "" , display: isEditClientPage ? "inline-block" : "" , left: isEditClientPage ? "-6%" : ""}}
                                      >
                                        <img className='back-btn-img' src={`/images/icons/back-arrow.svg`} alt='' />
                                        {/* <back-arrow/> */}
                                      </a>
                                    ) : (
                                      <></>  
                                    )}
                                    {!!isAdmin && !!userCompany && !!user ? (
                                      <>
                                        {isAdmin &&
                                          title &&
                                          isAdminBookingDetailsPage ? (
                                            <>
                                          <div className={`d-flex justify-content-between align-items-end mb-2`}>
                                          <div className={`d-flex justify-content-between align-items-start flex-wrap flex-column`}>
                                            {!isMobileBrowser && (
                                              <>
                                                {' '}
                                                <div className='d-flex align-items-center booking-number-id'>
                                                <p className='mb-0'><Link to='/sales-bookings/list/tab/all'>Bookings</Link>{title}</p>
                                                <div className='copy-to-clipboard'>
                                                {
                                                  isBookingNoCopied ?
                                                <img  src='/images/icons/copied.png' alt='copy booking No' className='' />
                                                :
                                                <img onClick={() => handleCopyToClipboard(title)} title='copy booking hyperlink' src='/images/icons/copy.png' alt='copy booking No' className='' />
                                                }
                                                </div>
                                                </div>
                                                <div className='d-inline-flex align-items-center flex-wrap'>
                                                <span
                                                  className={
                                                    // Keeping old code until making sure all good
                                                    // apiBadge ||
                                                    //   importantBooking ||
                                                    //   userFirstBooking ||
                                                    //   isPartnerBooking ||
                                                    //   isB2CBooking
                                                    //   ? fromQuote
                                                    //     ? 'd-flex flex-wrap'
                                                    //     : 'd-flex'
                                                    //   : ''
                                                    'd-inline-flex align-items-center flex-wrap mr-2'
                                                  }
                                                >
                                                 <span className={`d-inline-flex align-items-center ${companyVerified ? '' : 'mr-2'}`}>
                                                 {`${userCompany}`}
                                                 <Link title={userCompany} target='_blank' to={`/clients/edit/${userCompanyId}`}>
                                                 <img className='direct-to-comapny-btn' src='/images/icons/new_tab_brown_icon.svg' alt='company-url' />
                                                 </Link>
                                                  </span> 
                                                  {companyVerified ? 
                                                    <img
                                                      style={{ 
                                                        marginLeft:'0.250rem', marginBottom:'0',
                                                        height: '1.25rem', width: '1.25rem',
                                                        marginRight:'0.250rem'
                                                      }}
                                                      src={'/images/icon-verified.png'}
                                                      alt=''
                                                    />
                                                  : <></>}
                                                  {` | ${user}`}{' '}
                                                  <span 
                                                     className='masquerade-btn'
                                                  onClick={() => onMasquerade()}
                                                  >
                                                  
                                                  <img
                                                      src={'/images/icons/masquerade_icon.svg'}
                                                      alt='masquerade user button '
                                                    />
                                                  </span>
                                                </span>
                                                <span>
                                                  {userLabel && (
                                                    <Badge
                                                      href='#'
                                                      variant={`${userLabel}-user badge-outlined py-1`}
                                                      style={{
                                                        display: 'inline-block',
                                                        marginLeft: '0',
                                                        marginBottom: '0',
                                                      }}
                                                    >
                                                      {getLabelFromValue(defaultUserStatus, userLabel)}
                                                    </Badge>
                                                  )}
                                                  {isPartnerBooking ? (
                                                    <div className='partnerBadgeBooking d-inline-flex ml-2'>P</div>
                                                  ): <></>}
                                                  {isB2CBooking ? (
                                                    <div className='partnerBadgeBooking d-inline-flex ml-2'>W</div>
                                                  ): <></>}
                                                  {isRolzoFirst && isRolzoFirst===true ? 
                                                    <img
                                                      src='/images/icons/rolzo-first-icon.png'
                                                      alt=''
                                                      className='important-booking-badge mb-0 ml-2'
                                                    >
                                                    </img> : <></>}
                                                  <img
                                                    src={bespokeService ? '/images/icons/bespoke-icon.png' : '/images/icons/bespoke-icon-disabled.png'}
                                                    id='bespoke-icon'
                                                    style={{ cursor: 'pointer' }}
                                                    className='important-booking-badge mb-0'
                                                    alt=''
                                                  />
                                                  <img
                                                    style={{ width: '28px', height: '23px', marginLeft: '10px', marginBottom: '0', cursor: 'pointer' }}
                                                    id='vip-icon'
                                                    src={vipService ? '/images/icons/icon-vip.png' : '/images/icons/icon-vip-disabled.png'}
                                                    alt= ''
                                                  />
                                                  {apiBadge && (
                                                    <div className='apiBadgeBooking d-inline-flex ml-2'>
                                                      API
                                                    </div>
                                                  )}
                                                  {/* <img
                                                    src={(importantService || userFirstBooking) ? '/images/icons/icon-important.png' : '/images/icons/icon-important-disabled.png'}
                                                    id='important-icon'
                                                    style={{ cursor: 'pointer' }}
                                                    className='important-booking-badge mb-0'
                                                    alt=''
                                                  /> */}
                                                  <img
                                                    src={escalationService ? '/images/icons/escalation-icon.png' : '/images/icons/escalation-icon-disabled.png'}
                                                    id='escalation-icon'
                                                    style={{ cursor: 'pointer' }}
                                                    className='important-booking-badge mb-0 mr-2'
                                                    alt=''
                                                  />
                                                </span>
                                                </div>
                                              </>
                                            )}
                                          </div>

                                          <button
                                          onClick={() => setShowTracker(!showTracker)}
                                           type='button' className='add-to-tracker-btn'>
                                            <img src='/images/icons/plus-icon.png' alt='add to tracker' className=''/>
                                          Create a task
                                          </button>
                                          </div>
                                          <div className={`d-flex justify-content-between align-items-center flex-wrap mb-3`}>
                                          {isB2CUser ?
                                                <>
                                                  {bookingFor === 'someone_else' ? 
                                                    <span style={isRolzoFirst ? { fontSize: '13px' } : { fontSize: '16px'}}>
                                                      {`Email: `}<span>{userEmail}</span>{userIp && (<> | User IP: <span>{userIp}</span></>)}
                                                      {userLocalTime != null && userLocalTime !== '' && (<> | User local time: <span>{userLocalTime}</span></>)}
                                                    </span>
                                                  : 
                                                    <span style={isRolzoFirst ? { fontSize: '13px' } : { fontSize: '16px'}}>
                                                      {`Phone: `} <a href={`tel:${userPhone}`} className='ClickOnCall'> </a> {userPhone}
                                                      {` | Email: `}<span>{userEmail}</span> {userIp && (<> | User IP: <span>{userIp}</span></>)}
                                                      {userLocalTime != null && userLocalTime !== '' && (<> | User local time: <span>{userLocalTime}</span></>)}
                                                    </span>
                                                  }
                                                </>
                                                 : 
                                                 <>
                                                 <span style={{ fontSize: '14px' }}>
                                                  {/* {`Company: `} <a href={`tel:${companyPhone}`} className='ClickOnCall'>
                                                    {companyPhone}
                                                  </a> */}
                                                   {` Email: `} <a href={`mailto:${userEmail}`} className='ClickOnCall mr-1'> {userEmail}</a>
                                                  {`| Phone: `} <a href={`tel:${userPhone}`} className='ClickOnCall'> {userPhone}</a>
                                                  {/* {userIp && (<> | User IP: <span>{userIp}</span></>)} */}
                                                  {userLocalTime != null && userLocalTime !== '' && (<> | User local time: <span>{userLocalTime}</span></>)}
                                                </span> 
                                                </>
                                                }
                                                <div className="booking-tasks-links">

                                                  {[
                                                    ...(tasklinks.hasClientTask || []).map((taskId, i) => (
                                                      <Link
                                                        key={`client-${i}`}
                                                        className="task_link"
                                                        target="_blank"
                                                        to={`/tracker/clients?bookId=${bookingId}&taskId=${taskId}`}
                                                      >
                                                        Task #{i + 1}(Client)
                                                      </Link>
                                                    )),
                                                    ...(tasklinks.hasEscalationTask || []).map((taskId, i) => (
                                                      <Link
                                                        key={`escalation-${i}`}
                                                        className="task_link"
                                                        target="_blank"
                                                        to={`/tracker/escalations?bookId=${bookingId}&taskId=${taskId}`}
                                                      >
                                                        Escalation #{i + 1}
                                                      </Link>
                                                    )),
                                                    ...(tasklinks.hasFinanceTask || []).map((taskId, i) => (
                                                      <Link
                                                        key={`finance-${i}`}
                                                        className="task_link"
                                                        target="_blank"
                                                        to={`/tracker/finance?bookId=${bookingId}&taskId=${taskId}`}
                                                      >
                                                        Task #{i + 1}(Finance)
                                                      </Link>
                                                    )),
                                                    ...(tasklinks.hasOperationsTask || []).map((taskId, i) => (
                                                      <Link
                                                        key={`sd-${i}`}
                                                        className="task_link"
                                                        target="_blank"
                                                        to={`/tracker/operations?bookId=${bookingId}&taskId=${taskId}`}
                                                      >
                                                        Task #{i + 1}(Operations)
                                                      </Link>
                                                    )),
                                                    // ...(tasklinks.hasSupplyTask || []).map((taskId, i) => (
                                                    //   <Link
                                                    //     key={`supply-${i}`}
                                                    //     className="task_link"
                                                    //     target="_blank"
                                                    //     to={`/tracker/supply?bookId=${bookingId}&taskId=${taskId}`}
                                                    //   >
                                                    //     Task #{i + 1}(Supply)
                                                    //   </Link>
                                                    // )),
                                                  ].flatMap((element, i, arr) =>
                                                    i < arr.length - 1
                                                      ? [element, <span className='comma' key={`comma-${i}`}>, </span>]
                                                      : [element]
                                                  )}
                                                </div>

                                          </div>
                                          {fromQuote && (
                                                    <div
                                                      style={{
                                                        fontSize: '16px',
                                                        flexBasis: '10%',
                                                      }}
                                                    >
                                                      From Quote
                                                    </div>
                                                  )}
                                                  {fromDraft && (
                                                    <div
                                                      style={{
                                                        fontSize: '16px',
                                                        flexBasis: '100%',
                                                      }}
                                                    >
                                                      From Draft
                                                    </div>
                                                  )}
                                              {fromEvent && (
                                                <div
                                                  style={{
                                                    fontSize: '16px',
                                                    flexBasis: '100%',
                                                  }}
                                                >
                                                  From <Link style={{color:"#a79779"}} target='_blank' to={`/client-events/${eventId}`}>
                                                    Event
                                                  </Link>
                                                </div>
                                              )}
                                            </>
                                        ) : (
                                          <>{title}</>
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        {isSupplier && supplierStatus ? (
                                          <>
                                            {`${title}`}
                                            <Badge
                                              href='#'
                                              variant={`${supplierStatus.value}-partner badge-outlined py-1 p1-2 mb-2`}
                                              style={{
                                                display: 'inline-block',
                                                marginLeft: '1.3rem',
                                              }}
                                            >
                                              {supplierStatus.label}
                                            </Badge>
                                            <div class="partner-star-container">
                                              <div class="rating">
                                                <input type="checkbox" name="rating" id="rating-5" value={5} checked={rating === 5} />
                                                <label for="rating-5"></label>
                                                <input type="checkbox" name="rating" id="rating-4" value={4} checked={rating === 4} />
                                                <label for="rating-4"></label>
                                                <input type="checkbox" name="rating" id="rating-3" value={3} checked={rating === 3} />
                                                <label for="rating-3"></label>
                                                <input type="checkbox" name="rating" id="rating-2" value={2} checked={rating === 2} />
                                                <label for="rating-2"></label>
                                                <input type="checkbox" name="rating" id="rating-1" value={1} checked={rating === 1} />
                                                <label for="rating-1"></label>
                                              </div>
                                            </div>
                                            <img id='twenty-four-icon' class='supplier-icons'alt= ''
                                              src={twentyFourHourService ? '/images/icons/twenty-four-hour-icon.png' :
                                                '/images/icons/twenty-four-hour-icon-disabled.png' }
                                            />
                                            <img id='whatsapp-icon' class='supplier-icons'alt= ''
                                              src={supplierOnWhatsapp ? '/images/icons/whatsapp-icon.png' :
                                                '/images/icons/whatsapp-icon-disabled.png'}
                                            />
                                            {isIndependentDriver ? (<span style={{fontSize: '18px', position: 'absolute', right: '40px'}}>Independent Driver</span>) : (<></>)}
                                          </>
                                        ) : isPayout ? (
                                          <div className='d-flex flex-column'>
                                            <div>
                                            {`Payout #${title}`}
                                            <Badge
                                              href='#'
                                              variant={`${payoutStatus}-admin badge-outlined py-1 p1-2 mb-2`}
                                              style={{
                                                display: 'inline-block',
                                                marginLeft: '1.3rem',
                                              }}
                                            >
                                              {payoutStatus === 'paid' ? 'paid' : 
                                               payoutStatus === 'partially_paid' ? 'partially paid': 
                                               'pending'}
                                            </Badge>
                                            </div>
                                          {payoutCompany? <div className='d-flex align-items-center'> 
                                            <span style={{ fontSize: '18px' }}>{payoutCompany}</span><Link title={payoutCompany} target='_blank' to={`/partners/edit/${payoutCompanyId}`}>
                                                 <img className='direct-to-comapny-btn' src='/images/icons/new_tab_brown_icon.svg' alt='company-url' />
                                                 </Link></div> : <></>}
                                          </div>
                                        ) : (
                                          <> 
                                            {/* client side pages title */}
                                            <span 
                                            className={`${isMainClientPage && isMobileBrowser ? "justify-content-between" : ""} 
                                            ${isHomeBookingDetailsPage ? 'animated-header-text hide-booking-title' : ''}
                                            `}
                                            style={isMobileBrowser ? 
                                            isSettingsView || isChatNotification ? 
                                            { fontSize: isInvoicesPage ? "28px" : '16px', paddingBottom: '0', display: title === 'ROLZO First' ? 'block' : 'flex', justifyContent: 'center' , marginLeft: isMyProfile ? "55px" : "" , marginRight: isSettingsView && !isMyProfile ? '16px' : ""} 
                                            : 
                                             { fontSize: isMainClientPage && isMobileBrowser ? '18px' : '24px', display: 'flex' , paddingBlock: isMainClientPage && isMobileBrowser ? '16.5px' : ""  } :
                                              {}  }> 
                                              {title=== 'Invite new guest' && isMobileBrowser ? '' : `${title}`} 
                                              {isVipClient && !isMobileBrowser  ? (
                                                <img
                                                  src='/images/icons/icon-vip.png'
                                                  className='vip-passenger-img-b1'
                                                  alt=''
                                                />
                                              ) : (
                                                <></>
                                              )}
                                              {title === 'ROLZO First' && isMobileBrowser && company.isRolzoFirstMember ? (
                                                <img
                                                  src='/images/icons/rolzo-first-success.png'
                                                  alt=''
                                                  style={{ height: '15px', width: '15px', marginLeft: '0.5rem' }}
                                                />
                                              ) : (
                                                <></>
                                              )}

                                            {
                                              (isMainClientPage && isMobileBrowser) && (
                                                <div style={{ gap: "20px" }} className='d-none mobile-nav-icons align-items-center'>
                                                  <HeaderMenuItem
                                                    key='notification'
                                                    icon={'icon_notification_inactive.png'}
                                                    existUnread={existUnreadNotices}
                                                    onClickHandle={() => {
                                                      clickMenu('/notifications-client')
                                                    }}
                                                  />
                                                  <HeaderMenuItem
                                                    key='chat'
                                                    icon={'icon_chat_inactive.png'}
                                                    isClient={isClient}
                                                    existUnread={unreadMessages && unreadMessages > 0}
                                                    onClickHandle={() => {
                                                      clickMenu('/chat-client')
                                                    }}
                                                  />
                                                  <HeaderMenuItem
                                                    key='account'
                                                    icon={'menu_account_inactive.png'}
                                                    isAdmin={true}
                                                    onClickHandle={() => {
                                                      clickMenu('/settings/main')
                                                    }}
                                                  />
                                                </div>
                                              )
                                            }


                                            </span> 
                                            {isClientUserPage && userLabel && (
                                              <Badge
                                                href='#'
                                                variant={`${userLabel}-user badge-outlined py-1 mb-1`}
                                                style={{
                                                  display: 'inline-block',
                                                  marginLeft: '0.5rem',
                                                }}
                                              >
                                                {getLabelFromValue(defaultUserStatus, userLabel)}
                                              </Badge>
                                            )}
                                            {/* {isClientPage && isRolzoFirst && (
                                              <Badge
                                              href='#'
                                              variant={`rolzo-first badge-outlined py-1 mb-1`}
                                              style={{
                                                display: 'inline-block',
                                                marginLeft: '1rem',
                                              }}
                                            >
                                              First
                                            </Badge>
                                            )} */}
                                            {isClientPage && companyLabel && (
                                              <Badge
                                                href='#'
                                                variant={`${companyLabel}-user badge-outlined py-1 mb-1`}
                                                style={{
                                                  display: 'inline-block',
                                                  marginLeft: '1rem',
                                                }}
                                              >
                                                {getLabelFromValue(defaultCompanyStatus, companyLabel)}
                                              </Badge>
                                            )}
                                            {isClientPage && isRolzoFirst ===true ? 
                                              <img
                                                src='/images/icons/rolzo-first-icon.png'
                                                alt=''
                                                className='important-booking-badge mb-0 ml-2'
                                              >
                                              </img> : <></>}
                                            {/* {isClientPage && (
                                              <img
                                                src={importantClient  ? '/images/icons/icon-important.png' : '/images/icons/icon-important-disabled.png'}
                                                id='important-client-icon'
                                                style={{ cursor: 'pointer', marginLeft: '0.5rem' }}
                                                className='important-booking-badge mb-0'
                                                alt=''
                                              />
                                            )} */}
                                            </>
                                        )}
                                      </>
                                    )}
                                    <SmallDown>
                                      {!isMyProfile && subLink && (
                                        <a
                                          href={subLinkUrl || '#'}
                                          className='sub-link'
                                          onClick={onToggleUpdate}
                                        >
                                          {subLink}
                                        </a>
                                      )}
                                    </SmallDown>
                                  </>
                                ) : (
                                  <SmallUp>{title}</SmallUp>
                                )}
                                {!!isMyProfile && (
                                  <SmallDown>
                                    {subLink && (
                                      <a
                                        href={subLinkUrl || '#'}
                                        onClick={onToggleUpdate}
                                      >
                                        <div className='profile-change-password-link'>
                                          {subLink}
                                        </div>
                                      </a>
                                    )}
                                  </SmallDown>
                                )}
                                {!!showMobileTitle && (
                                  <SmallDown>
                                    <div
                                      className={
                                        subLink === 'Share'
                                          ? 'mobile-header-title-activity'
                                          : 'mobile-header-title'
                                      }
                                    >
                                      {title}
                                    </div>
                                    {subLink && (
                                      <a
                                        href={subLinkUrl || '#'}
                                        className='mobile-header-sub-link'
                                        style={{
                                          top: `-1px`,
                                        }}
                                        onClick={onToggleUpdate}
                                      >
                                        {!!isBookingView ? (
                                          <>
                                            {subLinkImg ? (
                                              <>
                                                {unreadMessages &&
                                                  unreadMessages > 0 ? (
                                                  <div className='mobile-header-sub-link-indecator'>
                                                    <div>
                                                      <img
                                                        className='supportbar-img'
                                                        src={subLinkImg}
                                                        alt=''
                                                      />
                                                    </div>
                                                    <div className='supportbar-unread-indicator' />
                                                    <div className='mobile-header-sub-linktext-with-indecator'>
                                                      {subLink}
                                                    </div>
                                                  </div>
                                                ) : (
                                                  <>
                                                    <div
                                                      className={
                                                        subLink === 'Share'
                                                          ? 'mobile-hader-img-wrapper-share'
                                                          : 'mobile-hader-img-wrapper'
                                                      }
                                                    >
                                                      <img
                                                        src={subLinkImg}
                                                        alt=''
                                                      />
                                                    </div>

                                                    <div className='mobile-header-sub-linktext'>
                                                      {subLink}
                                                    </div>
                                                  </>
                                                )}
                                              </>
                                            ) : (
                                              <div
                                                className={`${subLink === 'Follow' ||
                                                  subLink === 'Unfollow'
                                                  ? 'mobile-header-sub-link-textonly-golden'
                                                  : ''
                                                  } mobile-header-sub-link-textonly`}
                                              >
                                                {subLink}
                                              </div>
                                            )}
                                          </>
                                        ) : (
                                          <>
                                            {subLink && (
                                              <a
                                                href={subLinkUrl || '#'}
                                                className='sub-link'
                                                onClick={onToggleUpdate}
                                              >
                                                {subLink}
                                              </a>
                                            )}
                                          </>
                                        )}
                                      </a>
                                    )}
                                  </SmallDown>
                                )}
                              </div>
                              {subTitleBadgeGrey || subTitleBadgeBlack ? (
                                <>
                                  {isMobileBrowser && (
                                    <SmallUp>
                                      <Badge
                                        variant={`${subTitleBadgeGrey ||
                                          subTitleBadgeBlack} badge-outlined ml-3 py-1 px-2`}
                                      >
                                        {getLabelFromValue(
                                          defaultBookingStatus,
                                          subTitleBadgeGrey || subTitleBadgeBlack
                                        ) === 'Quote received'
                                          ? 'Quote sent'
                                          : getLabelFromValue(
                                            defaultBookingStatus,
                                            subTitleBadgeGrey ||
                                            subTitleBadgeBlack
                                          )}
                                        {/* {subTitleBadgeGrey || subTitleBadgeBlack} */}
                                      </Badge>
                                    </SmallUp>
                                  )}
                                </>
                              ) : (
                                ''
                              )}
                            </>
                          ) : (
                            renderStepper()
                          )}

                          {!!addEvent && (
                            <button
                              onClick={addEvent}
                              className={`add-btn ${title === 'Global rates' ? 'add-btn-global-rates' : ''}`}
                              style={{ background: 'none', border: 'none', padding: 0, marginRight:'14px', cursor: 'pointer' }}
                            >
                              <img src='/images/icons/add-btn.svg' alt='Add' />
                            </button>
                          )}
                          {!!addPath && (
                            <Link to={addPath} className={`add-btn ${title === 'Global rates' ? 'add-btn-global-rates': ''}`}>
                              <img src='/images/icons/add-btn.svg' alt='' />
                            </Link>
                          )}
                          {rolzoLocationCountryPage ? 
                            (<div className='add-btn'>
                              <img src='/images/icons/add-btn.svg' alt='' onClick={()=> setShowRolzoCountryModal(true)} />
                            </div>)
                            : (<></>)}
                          {rolzoLocationCityPage ? 
                            (<div className='add-btn'>
                              <img src='/images/icons/add-btn.svg' alt='' onClick={()=> setShowRolzoCityModal(true)} />
                            </div>)
                            : (<></>)}
                          {!!addPathMapping && (
                            <Link
                              to={addPathMapping}
                              className='align-items-center add-link text-brown'
                              style={{fontSize:"20px"}}
                            >
                              Vehicle Mapping
                            </Link>
                          )}
                        </>
                      ) : (
                        ''
                      )}
                      {subtitle && <p className='edit-client-subtitle'>
                        {subtitle} 
                        <TooltipOnHover
                          delay={200}
                          placement='right-start'
                          isMobileBrowser={isMobileBrowser}
                          onMouseEnter={() => {}}
                          component={
                            <div>
                              The confidentiality of your personal data is of utmost importance to us. Our{' '}
                              <span>
                                <a
                                  href='https://rolzo.com/privacy-policy'
                                  style={{ color: '#a79779' }}
                                  target='_blank'
                                  rel="noopener noreferrer"
                                >
                                  Privacy Policy
                                </a>
                              </span>{' '}
                              describes the information we collect and how we use it to enhance your experience while using our services.
                            </div>
                          }
                        >
                          <img
                            className={'new-info-icon'}
                            // style={{ marginLeft: '12px' }}
                            src='/images/icons/new-info-icon.png'
                            alt=''
                          />
                        </TooltipOnHover>
                      </p>}
                      {(onComposeEmail || onOpenSessionManager || onOpenEmailAccountManager) && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                          {onComposeEmail && (
                            <button
                              className='wa-toolbar-gear-btn'
                              onClick={onComposeEmail}
                              title='Compose'
                            >
                              <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
                                <path d='M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7' />
                                <path d='M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z' />
                              </svg>
                            </button>
                          )}
                          {(onOpenSessionManager || onOpenEmailAccountManager) && (
                            <button
                              className='wa-toolbar-gear-btn'
                              onClick={onOpenSessionManager || onOpenEmailAccountManager}
                              title='Channel Settings'
                            >
                              <img src='/images/icons/settings-gear.png' alt='Settings' />
                            </button>
                          )}
                        </div>
                      )}
                    </header>
                  </>
                }
              </Navbar.Brand>
              {false && !showBack && !showClose && !showStepper && (
                <Navbar.Toggle onClick={e => mobileSidebarToggle(e)} />
              )}
              <Navbar.Collapse></Navbar.Collapse>
            </Navbar>
          ) : (
            <></>
          )}
          {createdBy ? (
            <span className='createdBy-text'>
              {`Created by ${createdBy.name} on ${moment
                .utc(createdBy.createdAt)
                .format(' DD MMM YYYY')}`}
            </span>
          ) : (
            <></>
          )}
          <main
            className={`
              ${isHomePage ? 'home-page' : ''} 
              ${hideSidebar ? 'hide-sidebar' : ''} 
              ${noLeftPadding ? 'no-left-padding' : ''} ${
              noTitle ? 'no-title-main' : ''
            } ${showWarningBanner ? 'pt-0' : ''} ${
              removePageMargin && !isMobileBrowser
                ? isPayoutList
                  ? 'isAdminPayout'
                  : isAddClientPage
                  ? 'isAdminMain isAddClient'
                  : isRatesGrid
                  ? 'isRatesGrid'
                  : isRatesList
                  ? 'pt-0 pl-0'
                  : isEventPage
                  ? 'event-admin-main'
                  : 'isAdminMain'
                : ''
            } 
            ${isPayout ? 'payout-container' : ''} 
              ${
                title === 'Commissions' && isSettingsView ? 'no-top' : ''
              }                   
              ${PageMarginZero ? 'p-0' : ''}    
              ${isClientBookingsList ? 'bookings-list' : ''}
              ${
                isAdminBookingDetailsPage || isGlobalRates
                  ? 'booking-details-admin-page'
                  : ''
              }               
            `}
            style={{
              ...(isNewBooking && isSearchStep
                ? {
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                    minHeight: 'calc(100vh - 60px)',
                    height: 'calc(100vh - 60px)',
                  }
                : isNewBooking && !isSearchStep
                ? { minHeight: '100vh', height: 'inherit' }
                : isSupplier || isClientPage
                ? { paddingLeft: '1.0625rem' }
                : isSupplierList || isAdminList
                ? { paddingLeft: '20px', paddingRight: '20px' }
                : {}),
              ...(isHomePageLayout
                ? { paddingRight: '60px', paddingBottom: '67px' }
                : isEventPage
                ? { padding: '0px', width: '100%' }
                : {}),
              ...(isInviteNewGuestPage ? { paddingTop: '1rem' } : {}),
              ...(isVipMeetGreet ? { paddingRight: 0 } : {}),
            }}
          >
            {/* {isNewEvent ? <CarouselComponent /> : <></>} */}
            {renderTabs()}
            {children}
            {isMasqueradeUser && <MasquradeBanner />}
          </main>
        </div>
        <RolzoCountryModal
          onHide={() => {
            setShowRolzoCountryModal(false)
          }}
          show={showRolzoCountryModal}
        />
        <RolzoCityModal
          onHide={() => {
            setShowRolzoCityModal(false)
          }}
          show={showRolzoCityModal}
        />
        <AddTaskModal
          isOpen={showTracker}
          setEscalationService={setEscalationService}
          escalationService={escalationService}
          bookingId={bookingId}
          bookingType={bookingType}
          hasVipMg={hasVipMg}
          showFieldsOf={showEscalation ? 'escalation' : null}
          hideRadio={showEscalation ? true : false}
          onClose={() => {
            setShowTracker(false)
            setShowExcalation(false)
          }}
        />
      </>
    )
  }
)
const getUnreadMsgLength = appWebsocket => {
  if (appWebsocket.chatsList.length) {
    const found = appWebsocket.chatsList.find(
      chat => chat.type === 'chat_with_admin'
    )
    return found ? found.unreadByUserMessagesCount : 0
  }
}
const getUnReadNotificationsLength = appWebsocket => {
  if (appWebsocket.notificationsList && appWebsocket.notificationsList.length) {
    const found = appWebsocket.notificationsList.filter(
      notification => notification.readStatus === false
    )
    return found.length
  } else {
    return 0
  }
}
const mapStateToProps = ({
  auth: {
    isLoggedIn,
    company,
    companyId,
    isMasqueradeUser,
    userId,
    pricingModel,
    isReferral,
    isB2C,
    roles,
  },
  // appWebsocket,
}) => ({
  isLoggedIn,
  company,
  companyId,
  isMasqueradeUser,
  userId: userId,
  pricingModel,
  isReferral,
  companyRoles: roles.company,
  // chatsList: appWebsocket.chatsList,
  // unreadMessages: getUnreadMsgLength(appWebsocket),
  // notifications: getUnReadNotificationsLength(appWebsocket),
})

export default withRouter(
  connect(mapStateToProps, {
    forwardRef: true,
    logout,
    showNotification,
    removeFCMToken,
  })(DefaultLayout)
)
